var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15Z","fill":"#F2F2F2","key":0}),React.createElement("path",{"d":"M10.6666 19.6668C10.6677 20.02 10.8085 20.3585 11.0583 20.6083C11.3081 20.8581 11.6466 20.9989 11.9998 21H17.3332C17.6864 20.9989 18.0249 20.8581 18.2747 20.6083C18.5245 20.3585 18.6653 20.02 18.6664 19.6668V11.6664H10.6666V19.6668ZM19.3336 9.6666H17.0002L16.3336 9H13L12.3334 9.6666H10V10.9998H19.3336V9.6666Z","fill":"currentColor","key":1})]);
}

Delete.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Delete;

Delete.default = Delete;
